import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Log } from "ng2-logger";
import { ModalComponent, PdfViewerComponent } from "@app/shared/components";
import { Ticket } from "@models/ticket.model";
import { TicketOperation } from "@models/ticket-operation.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-ticket-details-modal',
    templateUrl: './ticket-details-modal.component.html',
    styleUrls: ['./ticket-details-modal.component.scss']
})
export class TicketDetailsModalComponent implements OnInit {
    _logger = Log.create(TicketDetailsModalComponent.name);

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @ViewChild(PdfViewerComponent, {static: true}) pdfViewer: PdfViewerComponent;

    @Output()
    closeTicket = new EventEmitter<any>();

    @Output()
    downloadFile = new EventEmitter<any>();

    ticket: Ticket;

    loading = false;

    constructor(private translateService: TranslateService) {
    }

    ngOnInit() {
    }

    open(ticket = new Ticket()) {
        this._logger.info('Opening modal with ticket', ticket);
        this.ticket = ticket;
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    doCleanup() {
        this.ticket = null;
    }

    emitCloseTicket() {
        this.closeTicket.emit(this.ticket);
    }

    computeOperationHeader(ticketOperation: TicketOperation) {
        const operationName = this.computeOperationNameWithIndex(ticketOperation);
        if (this.computeIsOpen(ticketOperation)) {
            return operationName + `- ${this.translateService.instant('generic.statuses.inProgress')}`;
        } else {
            return operationName;
        }
    }

    computeStatusClass(ticketOperation) {
        if (ticketOperation.isClosed) {
            return {'done': true};
        } else if (this.computeIsOpen(ticketOperation)) {
            return {'in-progress': true};
        } else {
            return {'not-started': true};
        }
    }

    computeIsOpen(ticketOperation: TicketOperation) {
        return this.ticket.currentOperation.id === ticketOperation.id && this.ticket.status === 'InProgress';
    }

    computeCanRenderCloseButton(ticket: Ticket) {
        return !(ticket.status === 'Closed');
    }

    download(file: any) {
        this.downloadFile.emit(file);
    }

    computeIsAutomatic() {
        return this.ticket.isAutomatic === true;
    }

    viewFile(file: any) {
        this.pdfViewer.open(file.url);
    }

    getOperationToolNames(ticketOperation: TicketOperation) {
        if (ticketOperation.ticketOperationTools && ticketOperation.ticketOperationTools.length !== 0) {
            return ticketOperation.ticketOperationTools.map(tot => tot.tool.name + '' + tot.tool.toolUid );
        }
    }

    computeRecurrences(ticketOperation: TicketOperation) {
        if (ticketOperation.ticketOperationRecurrences && ticketOperation.ticketOperationRecurrences.length !== 0) {
            return ticketOperation.ticketOperationRecurrences.map(tor => tor.recurrence);
        }
        return [];
    }

    computeTasks(ticketOperation: TicketOperation) {
        if (ticketOperation.ticketOperationTasks && ticketOperation.ticketOperationTasks.length !== 0) {
            return ticketOperation.ticketOperationTasks.map(tot => tot.operationTask);
        }
        return [];
    }

    private computeOperationNameWithIndex(ticketOperation: TicketOperation) {
        const operationWithSameName = this.ticket.ticketOperations.filter(item => item.name === ticketOperation.name);
        if (operationWithSameName.length !== 1) {
            for (let i = 0; i < operationWithSameName.length; i++) {
                if (operationWithSameName[i].priority === ticketOperation.priority) {
                    return `${ticketOperation.name}` + " #" + (i + 1);
                }
            }
        } else {
            return `${ticketOperation.name}`;
        }
    }
}
